module.exports = __webpack_public_path__ + "img/guizhouHints_12.60566bd5.jpg";